// extracted by mini-css-extract-plugin
export default {"extendOptionWidth":"styles_extendOptionWidth__dp9tj","editing":"styles_editing__4lYl7","message":"styles_message__e4jdw","formInput":"styles_formInput__JEOFo"};